import goggles from 'common/onboarding/immersive-onboarding/assets/goggles.webp';
import exploreNoEvents from 'common/onboarding/immersive-onboarding/assets/explore-no-events.webp';
import exploreCongratulations from 'common/onboarding/immersive-onboarding/assets/explore-congratulations.webp';
import companyKpisTemplate from 'common/onboarding/immersive-onboarding/assets/company_kpis_template.webp';
import featureLaunchTemplate from 'common/onboarding/immersive-onboarding/assets/feature_launch_template.webp';
import lifecycleCohortTemplate from 'common/onboarding/immersive-onboarding/assets/lifecycle_cohort_template.webp';
import marketingKpisTemplate from 'common/onboarding/immersive-onboarding/assets/marketing_kpis_template.webp';
import webAnalyticsTemplate from 'common/onboarding/immersive-onboarding/assets/web_analytics_template.webp';

export const IMMERSIVE_ASSETS = {
  goggles,
  exploreNoEvents,
  exploreCongratulations,
  companyKpisTemplate,
  featureLaunchTemplate,
  lifecycleCohortTemplate,
  marketingKpisTemplate,
  webAnalyticsTemplate,
};
